export const templateChallengeSubmit = String.raw`<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Host a challenge — Nemonto</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap" rel="stylesheet">
<style>
  :root{
    --spice:#D85A30; --spice-deep:#B23D18; --cream:#FAECE7; --peach:#F5C4B3;
    --charcoal:#2C2C2A; --herb:#1D9E75; --gold:#FAC775; --muted:#8A7A72;
    --serif:'DM Serif Display', Georgia, serif; --sans:'DM Sans', system-ui, sans-serif;
  }
  *{margin:0;padding:0;box-sizing:border-box;}
  body{background:#F1E4DE; color:var(--charcoal); font-family:var(--sans); font-size:14px; height:100vh; overflow:hidden;}
  a{color:inherit; text-decoration:none;}
  button{font-family:inherit; cursor:pointer; border:none; background:none;}
  input,textarea,select{font-family:inherit;}
  :focus-visible{outline:2.5px solid var(--spice); outline-offset:2px; border-radius:4px;}
  ::-webkit-scrollbar{width:7px;}
  ::-webkit-scrollbar-thumb{background:rgba(44,44,42,0.14); border-radius:10px;}
  ::-webkit-scrollbar-track{background:transparent;}

  .app{display:grid; grid-template-columns:1fr 420px; height:100vh; max-width:1320px; margin:0 auto;}

  /* ============ TOP BAR ============ */
  .topbar{
    position:fixed; top:0; left:0; right:0; height:64px; background:rgba(241,228,222,0.92); backdrop-filter:blur(8px);
    border-bottom:1px solid rgba(44,44,42,0.08); z-index:20; display:flex; align-items:center;
  }
  .topbar-inner{max-width:1320px; margin:0 auto; padding:0 28px; display:flex; align-items:center; justify-content:space-between; width:100%;}
  .tb-left{display:flex; align-items:center; gap:14px;}
  .close-btn{width:34px; height:34px; border-radius:50%; background:rgba(44,44,42,0.06); display:flex; align-items:center; justify-content:center; color:#6B5F58;}
  .tb-title{font-family:var(--serif); font-size:18px; display:flex; align-items:center; gap:9px;}
  .tb-flag{color:var(--gold); font-size:16px;}
  .tb-right{display:flex; align-items:center; gap:12px;}
  .draft-note{font-size:11.5px; color:#9A8C84; display:flex; align-items:center; gap:6px;}
  .draft-dot{width:6px; height:6px; border-radius:50%; background:var(--herb);}
  .publish-btn{background:var(--spice); color:#fff; font-size:13.5px; font-weight:700; padding:10px 22px; border-radius:30px; transition:transform .15s, box-shadow .15s, opacity .15s;}
  .publish-btn:hover{transform:translateY(-1px); box-shadow:0 10px 22px rgba(216,90,48,0.3);}
  .publish-btn:disabled{opacity:0.45; cursor:not-allowed; transform:none; box-shadow:none;}

  /* ============ FORM COLUMN ============ */
  .form-col{height:100vh; overflow-y:auto; padding:84px 48px 80px;}
  .form-wrap{max-width:560px; margin:0 auto;}

  .intro-banner{
    background:rgba(250,199,117,0.16); border:1px solid rgba(250,199,117,0.4); border-radius:16px; padding:14px 16px;
    display:flex; gap:10px; margin-bottom:30px; font-size:12.5px; color:#8A5A00; line-height:1.55;
  }

  .progress-rail{display:flex; gap:8px; margin-bottom:32px;}
  .progress-seg{flex:1; height:4px; border-radius:3px; background:rgba(44,44,42,0.1);}
  .progress-seg.done{background:var(--spice);}

  .form-section{margin-bottom:38px;}
  .fs-label{font-size:11.5px; font-weight:700; letter-spacing:0.06em; text-transform:uppercase; color:var(--spice-deep); margin-bottom:14px; display:flex; align-items:center; gap:8px;}
  .fs-num{width:22px; height:22px; border-radius:50%; background:rgba(216,90,48,0.12); display:flex; align-items:center; justify-content:center; font-size:11px; font-family:var(--serif);}
  .fs-hint{font-size:11.5px; color:#9A8C84; font-weight:400; text-transform:none; letter-spacing:0; margin-left:auto;}

  .field{margin-bottom:16px;}
  .field-label{font-size:12.5px; font-weight:600; color:var(--charcoal); margin-bottom:6px; display:block;}
  .field-input, .field-textarea, .field-select{
    width:100%; background:#fff; border:1.5px solid rgba(44,44,42,0.1); border-radius:13px; padding:12px 15px;
    font-size:13.5px; color:var(--charcoal); outline:none; transition:border-color .15s;
  }
  .field-input:focus, .field-textarea:focus, .field-select:focus{border-color:var(--spice);}
  .field-textarea{resize:vertical; min-height:70px; line-height:1.5;}
  .char-count{font-size:11px; color:#9A8C84; text-align:right; margin-top:4px;}
  .field-row{display:flex; gap:12px;}
  .field-row .field{flex:1;}

  .chip-row{display:flex; gap:8px; flex-wrap:wrap;}
  .chip{
    background:#fff; border:1.5px solid rgba(44,44,42,0.1); color:#6B5F58; font-size:12.5px; font-weight:600;
    padding:8px 14px; border-radius:20px; transition:all .15s;
  }
  .chip.selected{background:var(--spice); color:#fff; border-color:var(--spice);}

  /* required ingredients builder */
  .ing-builder{background:#fff; border-radius:16px; padding:14px; border:1px solid rgba(44,44,42,0.06);}
  .ing-current{display:flex; gap:7px; flex-wrap:wrap; margin-bottom:12px; min-height:34px;}
  .ing-pill{background:var(--cream); color:var(--spice-deep); font-size:12.5px; font-weight:600; padding:7px 12px; border-radius:20px; display:flex; align-items:center; gap:7px;}
  .ing-pill button{color:var(--spice-deep); opacity:0.6; font-size:12px;}
  .ing-add-row{display:flex; gap:8px;}
  .ing-add-row input{flex:1;}
  .ing-add-btn{background:var(--charcoal); color:#fff; width:42px; border-radius:12px; flex-shrink:0; font-size:16px;}
  .ing-limit-note{font-size:11px; color:#9A8C84; margin-top:8px;}

  /* duration picker */
  .duration-row{display:flex; gap:8px;}
  .duration-opt{
    flex:1; background:#fff; border:1.5px solid rgba(44,44,42,0.1); border-radius:14px; padding:13px 8px; text-align:center;
    cursor:pointer; transition:all .15s;
  }
  .duration-opt.selected{background:var(--spice); border-color:var(--spice);}
  .duration-opt b{display:block; font-size:14.5px; font-family:var(--serif); color:var(--charcoal); margin-bottom:2px;}
  .duration-opt span{font-size:10.5px; color:#9A8C84;}
  .duration-opt.selected b, .duration-opt.selected span{color:#fff;}

  .toggle-row{display:flex; align-items:center; justify-content:space-between; background:#fff; border-radius:14px; padding:13px 16px; border:1px solid rgba(44,44,42,0.06); margin-bottom:10px;}
  .toggle-row-text b{font-size:13px; display:block;}
  .toggle-row-text span{font-size:11.5px; color:#9A8C84;}
  .toggle-switch{width:42px; height:24px; border-radius:14px; background:rgba(44,44,42,0.15); position:relative; flex-shrink:0; transition:background .2s;}
  .toggle-switch.on{background:var(--spice);}
  .toggle-knob{position:absolute; top:3px; left:3px; width:18px; height:18px; border-radius:50%; background:#fff; transition:transform .2s; box-shadow:0 1px 3px rgba(0,0,0,0.2);}
  .toggle-switch.on .toggle-knob{transform:translateX(18px);}

  .reach-banner{
    background:#fff; border-radius:16px; padding:16px; border:1px solid rgba(44,44,42,0.06); display:flex; align-items:center; gap:14px;
  }
  .reach-num{font-family:var(--serif); font-size:24px; color:var(--spice-deep);}
  .reach-text{font-size:12px; color:#9A8C84; line-height:1.4;}
  .reach-bar-wrap{flex:1; height:6px; background:rgba(44,44,42,0.08); border-radius:4px; overflow:hidden; margin-top:8px;}
  .reach-bar{width:78%; height:100%; background:var(--spice); border-radius:4px;}

  /* ============ PREVIEW COLUMN ============ */
  .preview-col{height:100vh; overflow-y:auto; padding:84px 32px 60px; background:#F8EFEB; border-left:1px solid rgba(44,44,42,0.06);}
  .preview-sticky{position:sticky; top:0;}
  .preview-label{font-size:11.5px; font-weight:700; letter-spacing:0.06em; text-transform:uppercase; color:#9A8C84; margin-bottom:14px; text-align:center;}

  .preview-card{
    background:var(--charcoal); border-radius:22px; overflow:hidden; position:relative; padding:18px;
    box-shadow:0 24px 50px -20px rgba(44,28,18,0.3);
  }
  .preview-card::before{content:''; position:absolute; top:-60px; right:-50px; width:160px; height:160px; background:radial-gradient(circle, rgba(216,90,48,0.35), transparent 70%); pointer-events:none;}

  .pv-host-row{display:flex; align-items:center; gap:9px; margin-bottom:14px; position:relative;}
  .pv-host-avatar{width:30px; height:30px; border-radius:50%; background:#9FE1CB; flex-shrink:0;}
  .pv-host-name{font-size:12.5px; font-weight:600; color:var(--cream);}
  .pv-host-tag{font-size:10px; color:rgba(250,236,231,0.5);}
  .pv-live-pill{margin-left:auto; background:var(--spice); color:#fff; font-size:10px; font-weight:700; padding:4px 10px; border-radius:20px; display:flex; align-items:center; gap:5px;}
  .pv-live-pill .dot{width:5px; height:5px; border-radius:50%; background:#fff;}

  .pv-title{font-family:var(--serif); font-size:18px; color:var(--cream); line-height:1.3; margin-bottom:10px; position:relative; min-height:24px;}
  .pv-title.placeholder{color:rgba(250,236,231,0.35);}

  .pv-ingredient-chips{display:flex; gap:6px; flex-wrap:wrap; margin-bottom:14px; position:relative; min-height:26px;}
  .pv-ing-chip{background:rgba(250,236,231,0.1); color:var(--cream); font-size:11px; padding:5px 10px; border-radius:20px;}
  .pv-ing-chip.placeholder{color:rgba(250,236,231,0.3); background:transparent; border:1px dashed rgba(250,236,231,0.2);}

  .pv-stats-row{display:flex; gap:9px; margin-bottom:14px; position:relative;}
  .pv-stat{flex:1; background:rgba(250,236,231,0.07); border-radius:11px; padding:9px; text-align:center;}
  .pv-stat b{display:block; font-size:15px; color:var(--gold); font-family:var(--serif);}
  .pv-stat span{font-size:9.5px; color:rgba(250,236,231,0.55);}

  .pv-message{
    background:rgba(250,236,231,0.06); border-radius:12px; padding:11px 13px; font-size:12px; font-style:italic;
    color:rgba(250,236,231,0.8); line-height:1.5; position:relative; margin-bottom:14px; min-height:20px;
  }
  .pv-message.placeholder{color:rgba(250,236,231,0.3);}

  .pv-enter-btn{display:block; text-align:center; background:var(--gold); color:#5A3A00; font-size:13px; font-weight:700; padding:11px 0; border-radius:14px; position:relative;}

  .preview-tip{
    background:rgba(255,255,255,0.6); border-radius:14px; padding:13px 16px; margin-top:18px; font-size:12px;
    color:#6B5F58; line-height:1.55; display:flex; gap:9px;
  }

  @media (max-width:980px){
    .app{grid-template-columns:1fr;}
    .preview-col{display:none;}
  }
</style>
</head>
<body>

<div class="topbar">
  <div class="topbar-inner">
    <div class="tb-left">
      <button class="close-btn" aria-label="Close">
        <svg width="15" height="15" viewBox="0 0 16 16"><path d="M2 2l12 12M14 2L2 14" stroke="#6B5F58" stroke-width="1.6" stroke-linecap="round"/></svg>
      </button>
      <span class="tb-title"><span class="tb-flag">⚑</span>Host a challenge</span>
    </div>
    <div class="tb-right">
      <span class="draft-note"><span class="draft-dot"></span>Draft saved</span>
      <button class="publish-btn" id="publishBtn" disabled>Launch challenge</button>
    </div>
  </div>
</div>

<div class="app">

  <!-- ================= FORM COLUMN ================= -->
  <main class="form-col">
    <div class="form-wrap">

      <div class="intro-banner">
        <span>🏅</span>
        <span>As the host, you set the rules and you personally pick the winner. No algorithm, no like-count contest — just your judgment.</span>
      </div>

      <div class="progress-rail">
        <div class="progress-seg done"></div>
        <div class="progress-seg done"></div>
        <div class="progress-seg"></div>
        <div class="progress-seg"></div>
      </div>

      <!-- TITLE & BRIEF -->
      <div class="form-section">
        <div class="fs-label"><span class="fs-num">1</span>The challenge</div>

        <div class="field">
          <label class="field-label">Challenge title</label>
          <input class="field-input" id="titleInput" type="text" placeholder="e.g. Pasta with 3 ingredients only" maxlength="60">
        </div>

        <div class="field">
          <label class="field-label">Your message to participants</label>
          <textarea class="field-textarea" id="msgInput" placeholder="What do you want to see? What's off-limits?" maxlength="180"></textarea>
          <div class="char-count"><span id="msgCount">0</span> / 180</div>
        </div>
      </div>

      <!-- CUISINE -->
      <div class="form-section">
        <div class="fs-label"><span class="fs-num">2</span>Cuisine type</div>
        <div class="chip-row" id="cuisineChips">
          <button class="chip selected">🍝 Italian</button>
          <button class="chip">🍛 South Asian</button>
          <button class="chip">🌮 Mexican</button>
          <button class="chip">🥘 Middle Eastern</button>
          <button class="chip">🍜 East Asian</button>
          <button class="chip">🥗 Healthy</button>
          <button class="chip">🍖 BBQ</button>
          <button class="chip">🥐 Bakery</button>
        </div>
      </div>

      <!-- REQUIRED INGREDIENTS -->
      <div class="form-section">
        <div class="fs-label"><span class="fs-num">3</span>Required ingredients <span class="fs-hint">What everyone must use</span></div>
        <div class="ing-builder">
          <div class="ing-current" id="ingCurrent">
            <span class="ing-pill">🍝 Pasta <button data-remove>✕</button></span>
            <span class="ing-pill">🥚 Eggs <button data-remove>✕</button></span>
            <span class="ing-pill">🧀 Pecorino <button data-remove>✕</button></span>
          </div>
          <div class="ing-add-row">
            <input class="field-input" id="ingInput" type="text" placeholder="Type an ingredient and press add">
            <button class="ing-add-btn" id="ingAddBtn">+</button>
          </div>
          <p class="ing-limit-note">Keep it to 3–5 ingredients — fewer constraints means more creative entries.</p>
        </div>
      </div>

      <!-- COOK TIME & SERVINGS -->
      <div class="form-section">
        <div class="fs-label"><span class="fs-num">4</span>Constraints</div>
        <div class="field-row">
          <div class="field">
            <label class="field-label">Max cook time</label>
            <div style="display:flex; gap:8px;">
              <input class="field-input" id="cookTime" type="number" placeholder="30" value="30">
              <select class="field-select" style="flex:0 0 90px;">
                <option>min</option>
                <option>hr</option>
              </select>
            </div>
          </div>
          <div class="field">
            <label class="field-label">Max servings</label>
            <input class="field-input" id="servings" type="number" placeholder="2" value="2">
          </div>
        </div>
      </div>

      <!-- DURATION -->
      <div class="form-section">
        <div class="fs-label"><span class="fs-num">5</span>How long should this run?</div>
        <div class="duration-row" id="durationRow">
          <div class="duration-opt" data-hours="24"><b>24 hrs</b><span>Fast & urgent</span></div>
          <div class="duration-opt selected" data-hours="72"><b>3 days</b><span>Recommended</span></div>
          <div class="duration-opt" data-hours="168"><b>1 week</b><span>More entries</span></div>
        </div>
      </div>

      <!-- REACH -->
      <div class="form-section">
        <div class="fs-label"><span class="fs-num">6</span>Who gets notified</div>
        <div class="reach-banner">
          <div style="flex:1;">
            <span class="reach-num">8,200</span>
            <p class="reach-text">followers will be notified the moment this goes live</p>
            <div class="reach-bar-wrap"><div class="reach-bar"></div></div>
          </div>
        </div>
      </div>

      <!-- SETTINGS -->
      <div class="form-section">
        <div class="fs-label"><span class="fs-num">7</span>Settings</div>
        <div class="toggle-row">
          <div class="toggle-row-text"><b>Disqualify entries with extra ingredients</b><span>Only allow the required ingredients you listed above</span></div>
          <div class="toggle-switch on" data-toggle><div class="toggle-knob"></div></div>
        </div>
        <div class="toggle-row">
          <div class="toggle-row-text"><b>Allow community comments on entries</b><span>Let people cheer on or give tips to participants</span></div>
          <div class="toggle-switch on" data-toggle><div class="toggle-knob"></div></div>
        </div>
        <div class="toggle-row">
          <div class="toggle-row-text"><b>Share to Instagram &amp; TikTok</b><span>Cross-post a teaser when this goes live</span></div>
          <div class="toggle-switch" data-toggle><div class="toggle-knob"></div></div>
        </div>
      </div>

    </div>
  </main>

  <!-- ================= PREVIEW COLUMN ================= -->
  <aside class="preview-col">
    <div class="preview-sticky">
      <p class="preview-label">How this will look</p>

      <div class="preview-card">
        <div class="pv-host-row">
          <div class="pv-host-avatar"></div>
          <div><div class="pv-host-name">Maria K.</div><div class="pv-host-tag">Challenge host</div></div>
          <span class="pv-live-pill"><span class="dot"></span>LIVE NOW</span>
        </div>

        <p class="pv-title placeholder" id="pvTitle">Your challenge title</p>

        <div class="pv-ingredient-chips" id="pvIngChips">
          <span class="pv-ing-chip">🍝 Pasta</span>
          <span class="pv-ing-chip">🥚 Eggs</span>
          <span class="pv-ing-chip">🧀 Pecorino</span>
        </div>

        <div class="pv-stats-row">
          <div class="pv-stat"><b>0</b><span>entries</span></div>
          <div class="pv-stat"><b id="pvCook">30m</b><span>max cook</span></div>
          <div class="pv-stat"><b id="pvDuration">72h</b><span>remaining</span></div>
        </div>

        <p class="pv-message placeholder" id="pvMsg">Your message to participants will appear here.</p>

        <a href="#" class="pv-enter-btn">Enter this challenge</a>
      </div>

      <div class="preview-tip">
        <span>💡</span>
        <span>This is exactly what followers will see in their feed and on the Challenges tab the moment you launch.</span>
      </div>
    </div>
  </aside>

</div>

<script>
  const titleInput = document.getElementById('titleInput');
  const msgInput = document.getElementById('msgInput');
  const msgCount = document.getElementById('msgCount');
  const cookTime = document.getElementById('cookTime');
  const pvTitle = document.getElementById('pvTitle');
  const pvMsg = document.getElementById('pvMsg');
  const pvCook = document.getElementById('pvCook');
  const pvDuration = document.getElementById('pvDuration');
  const publishBtn = document.getElementById('publishBtn');
  const pvIngChips = document.getElementById('pvIngChips');
  const ingCurrent = document.getElementById('ingCurrent');

  function ingredientCount(){
    return ingCurrent.querySelectorAll('.ing-pill').length;
  }

  function checkPublishable(){
    const ready = titleInput.value.trim().length > 2 && ingredientCount() > 0;
    publishBtn.disabled = !ready;
  }

  titleInput.addEventListener('input', () => {
    pvTitle.textContent = titleInput.value || 'Your challenge title';
    pvTitle.classList.toggle('placeholder', !titleInput.value);
    checkPublishable();
  });

  msgInput.addEventListener('input', () => {
    msgCount.textContent = msgInput.value.length;
    pvMsg.textContent = msgInput.value || 'Your message to participants will appear here.';
    pvMsg.classList.toggle('placeholder', !msgInput.value);
  });

  cookTime.addEventListener('input', () => {
    pvCook.textContent = (cookTime.value || '—') + 'm';
  });

  document.getElementById('cuisineChips').addEventListener('click', (e) => {
    if(!e.target.classList.contains('chip')) return;
    document.querySelectorAll('#cuisineChips .chip').forEach(c => c.classList.remove('selected'));
    e.target.classList.add('selected');
  });

  function syncIngredientPreview(){
    const pills = [...ingCurrent.querySelectorAll('.ing-pill')];
    pvIngChips.innerHTML = pills.length
      ? pills.map(p => \`<span class="pv-ing-chip">\${p.textContent.replace('✕','').trim()}</span>\`).join('')
      : '<span class="pv-ing-chip placeholder">Add required ingredients</span>';
    checkPublishable();
  }

  function bindRemove(pill){
    pill.querySelector('[data-remove]').addEventListener('click', () => {
      pill.remove();
      syncIngredientPreview();
    });
  }
  ingCurrent.querySelectorAll('.ing-pill').forEach(bindRemove);

  document.getElementById('ingAddBtn').addEventListener('click', addIngredient);
  document.getElementById('ingInput').addEventListener('keypress', (e) => {
    if(e.key === 'Enter'){ e.preventDefault(); addIngredient(); }
  });

  function addIngredient(){
    const input = document.getElementById('ingInput');
    const val = input.value.trim();
    if(!val) return;
    const pill = document.createElement('span');
    pill.className = 'ing-pill';
    pill.innerHTML = \`\${val} <button data-remove>✕</button>\`;
    ingCurrent.appendChild(pill);
    bindRemove(pill);
    input.value = '';
    syncIngredientPreview();
  }

  document.querySelectorAll('#durationRow .duration-opt').forEach(opt => {
    opt.addEventListener('click', () => {
      document.querySelectorAll('#durationRow .duration-opt').forEach(o => o.classList.remove('selected'));
      opt.classList.add('selected');
      const hours = parseInt(opt.dataset.hours);
      pvDuration.textContent = hours >= 24 ? Math.round(hours/24) + (hours === 24 ? 'd' : 'd') : hours + 'h';
      pvDuration.textContent = hours === 24 ? '24h' : hours === 72 ? '72h' : '168h';
    });
  });

  document.querySelectorAll('[data-toggle]').forEach(t => {
    t.addEventListener('click', () => t.classList.toggle('on'));
  });

  checkPublishable();
</script>

</body>
</html>
`;
